import { createContext } from "react";

const PersonalPageContext = createContext({});

export default PersonalPageContext;
